var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.671 1.00934C75.887 2.37734 85.607 5.04128 96.767 9.00128C95.759 11.8093 96.047 14.6173 97.631 17.1373C99.143 19.5853 101.591 21.0973 104.543 21.3853C103.535 29.3773 101.735 37.9453 98.855 46.6573C83.734 36.3613 71.135 15.8413 66.671 1.00934Z",
    fill: "url(#paint0_linear_1_3295)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.759 92.8083C63.935 97.1283 58.463 101.088 52.271 104.76C38.447 96.6243 28.079 86.6163 20.375 75.8883C39.167 78.7683 54.287 83.9523 68.759 92.8083Z",
    fill: "url(#paint1_linear_1_3295)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.703 9.00126C24.767 2.95326 38.519 -0.0707441 52.271 0.00125593C54.143 0.00125593 56.015 0.0732989 57.887 0.145299C63.215 21.3853 75.959 45.5053 93.671 59.6163C89.279 69.7683 84.671 76.4643 76.175 85.5363C61.415 70.7043 37.727 63.5763 13.536 64.9443C5.616 50.2563 1.656 34.9203 0 21.3843C2.88 21.0963 5.328 19.5843 6.912 17.1363C8.495 14.6173 8.783 11.8093 7.703 9.00126ZM61.055 41.8333C62.855 39.8893 63.935 37.2253 63.935 34.3453C63.935 28.2253 59.039 23.2573 52.919 23.2573C46.799 23.2573 41.831 28.2253 41.831 34.3453C41.831 37.2253 42.911 39.8893 44.711 41.8333C45.359 42.5533 45.719 43.4893 45.503 44.4253L42.191 59.5453C42.047 60.4813 42.335 61.3453 42.911 62.0653C43.487 62.7853 44.351 63.1453 45.287 63.1453H60.479C61.415 63.1453 62.279 62.7853 62.855 62.0653C63.503 61.3453 63.791 60.4813 63.575 59.5453L60.263 44.4253C60.047 43.4893 60.407 42.5533 61.055 41.8333Z",
    fill: "url(#paint2_linear_1_3295)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_3295",
    x1: 77.1776,
    y1: 31.3231,
    x2: 87.6486,
    y2: 17.2759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_3295",
    x1: 38.1824,
    y1: 89.183,
    x2: 51.5658,
    y2: 80.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_3295",
    x1: 33.7403,
    y1: 55.6042,
    x2: 59.6538,
    y2: 29.2521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5098,
    stopColor: "#ED638A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37197"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.c8bc14fb0b106bdba887f4d7a584a5a0.svg";
export { ForwardRef as ReactComponent };